import React from "react";
import { formatImageUrl, getClubsDir } from "../../utils";
import Picture from "../Picture";
import { useReactAppState } from "../../containers/utils";
import { trackClubClick } from "../../../../libraries/_modules/tracking/snowplow/trackClubInteraction";

const ClubLogo = ({ club, element_position }) => {
  const { isLeague, urlList } = useReactAppState();
  const { baseUrl } = urlList || {};
  const { logoColorUrl, fullName } = club || {};

  const { highQuality } = logoColorUrl ? formatImageUrl(logoColorUrl, { format: "w_128,h_128,c_pad", extension: "f_png" }) : {};
  const clubSlug = club?.slug;

  const handleClubClick = (e) => {
    e.preventDefault();

    const href = e.currentTarget.href;

    trackClubClick({
      clubData: {
        id: club?.id || club?.sportecId,
        name: fullName
      },
      element_name: clubSlug,
      element_type: "club",
      element_position,
    });

    setTimeout(() => {
      window.location.href = href;
    }, 100);
  };

  return (
    isLeague ?
      <a href={`${baseUrl}/${getClubsDir()}/${clubSlug}`} title={fullName} onClick={handleClubClick}>
        <Picture title={`${fullName} club logo`} src={highQuality} />
      </a>
      :
      <Picture title={`${fullName} club logo`} src={highQuality} />
  );
};

export default ClubLogo;
